import Select, { SingleValue } from "react-select";
import { useSnapshot } from "valtio";
import { clientDashboardEvents } from "../clientDashboardEvents";

type Option = { label: string; value: string };

export const OPTIONS: Option[] = [
    { label: "Last 30 Days", value: "30" },
    { label: "Last 60 Days", value: "60" },
    { label: "Last 90 Days", value: "90" },
    { label: "Last 120 Days", value: "120" },
    { label: "Last 6 Months", value: "180" },
    { label: "Last Year", value: "365" },
];

export default function DaysSelect() {
    const snap = useSnapshot(clientDashboardEvents);
    const selected = OPTIONS.find((o) => o.value === snap.days) ?? OPTIONS[0];

    return (
        <div className="dash-filter">
            <Select<Option, false>
                options={OPTIONS}
                value={selected}
                onChange={(opt: SingleValue<Option>) => {
                    if (opt) clientDashboardEvents.triggerDaysChanged(opt.value);
                }}
                menuPlacement="bottom"
                isClearable={false}
            />
        </div>
    );
}
